import theme from '../../../../../lib/theme';

const {
  layouts,
  colors,
  scale,
  media,
  font: { families, heights, spacings, ...font },
} = theme;

export default () => ({
  section: {
    ...layouts.column,
    backgroundColor: '#ffeffa',

    alignItems: 'center',
    padding: `${scale.m} ${scale.xs} ${scale.m}`,
  },

  noBackground: {
    backgroundColor: 'transparent !important',
  },

  profileContainer: {
    marginTop: '0',
  },

  formGroupContainer: {
    ...layouts.row,
    flexWrap: 'wrap',
    gap: `${scale.xxs}`,

    [media.l.down]: {
      ...layouts.column,
    },
  },

  formGroup: {
    ...layouts.row,
    flex: `1 0 calc(${100 / 2}% - 1rem)`,
    maxWidth: `calc(${100 / 2}% - 1rem)`,

    [media.l.down]: {
      ...layouts.column,
      flex: `1 0 calc(${100 / 1}% - 1rem)`,
      maxWidth: `${100 / 1}%`,  
    },

    '> label': {
      textAlign: 'left',
      padding: `4px 0`,
      flex: `0 0 30%`,
    },
  },

  genderGroup: {
    'select': {
      [media.l.down]: {
        maxWidth: `50%`,  
      },
    },
  },

  postcodeGroup: {
    'input': {
      [media.l.down]: {
        maxWidth: `50%`,  
      },
    },
  },

  dobGroup: {
    'div': {
      display: 'flex',

      [media.l.down]: {
        maxWidth: `75%`,  
      },

      [media.s.down]: {
        maxWidth: `100%`,  
      },
    },
  },

  '.form-control': {
    padding: `10px ${scale.xs} !important`,
  },

  controlsContainer : {
    padding: `${scale.s} 0 0`,
    marginTop: '0 !important',
  },

  subscriptions: {
    justifyContent: 'center !important',
    alignItems: 'stretch !important',
    flexWrap: 'wrap',
    gap: `${scale.xxs}`,
    marginTop: '0',
  },

  subscriptionItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: '#ffffff',
    border: `2px solid ${colors.sas.primary}`,
    flexWrap: 'wrap',
    flex: `0 0 calc(${100 / 3}% - ${scale.xxs}) !important`,
    cursor: 'pointer',

    [media.l.down]: {
      flex: `0 0 calc(${100 / 2}% - ${scale.xxs}) !important`,
    },

    [media.s.down]: {
      flex: `0 0 calc(100% - ${scale.xxs}) !important`,
    },

    '> img': {
      width: '100%',
      height: 'auto',
      margin: '0 auto',
    },

    '> h4': {
      fontSize: '1.5rem',
      fontWeight: '700',
    },

    '> p': {
      fontSize: '1rem',
    },

    '> p, > h4': {
      color: `${colors.sas.primary}`,
      display: 'flex',
      alignItems: 'center',
      textAlign: 'center',
      flex: '1',
    },

    '> input[type=checkbox]': {
      display: 'none',
    },

    '> .Icon': {
      color: `${colors.sas.primary}`,
      marginBottom: '0.5rem',
    },

    '> input[type=checkbox]:checked + .Icon': {
      backgroundColor: '#ffffff',
      color: `${colors.sas.primary}`,
      borderRadius: '50%',
    },
  },

  dobContainer: {
    gap: '0.5rem',

    '> *': {
      flex: '1',
    },
  },

  unSubscribePromptContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    gap: '1rem',
  },

  alert: {
    fontSize: '1.1rem',
    width: '100%',
    margin: `${scale.s} 0 0`,
  }
});
